import React, {Component, useEffect} from 'react';
import {css} from "@emotion/css";
import avatarIcon from "../../assets/images/header/avatar_12.jpg"
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import {FormControl, Grid} from "@mui/material";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import {useState} from "react";
import {convertToMobileNumber} from "../../util/numberConvertor";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";


const UserProfileDetailPage = (
    {
        profileDetail,
        setProfileDetail,
        service,
        adminId = -1,
        avatarUrl,
        setAvatarUrl
    }) => {

    const snackbarDispatcher = useSnackbarDispatcher()
    const snackbar = new SnackbarHelper(snackbarDispatcher)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setProfileDataToFields();
        }
    }, [profileDetail])

    function setProfileDataToFields() {
        setFirstName(profileDetail.firstName)
        setLastName(profileDetail.lastName)
        setUserName(profileDetail.username)
        setPhoneNumber(profileDetail.phoneNumber)
    }

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [imageFile, setImageFile] = useState(null);
    const [imageId, setImageId] = useState(-1);
    const [image, setImage] = useState(null)

    // const [avatarUrl, setAvatarUrl] = useState("");

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setImageFile(event.target.files[0]);
            setImageId(-1)
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    }

    function eraseImage() {
        setImageFile(null)
        setImage(null)
        setImageId(-1)
    }

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.length === 0)
            message = "لطفا نام ادمین را وارد نمایید!"
        else if (lastName.length === 0)
            message = "لطفا نام خانوادگی ادمین را وارد نمایید!"
        else if (phoneNumber.length !== 11)
            message = "لطفا شماره همراه ادمین را به درستی وارد نمایید!"
        else
            state = true

        snackbar.showWarningMessage(message)

        return state
    }

    function handleUpdateDetail() {
        if (checkFields()) {
            if (adminId >= 0) {
                updateManagerInfo()
            } else {
                updateAdminInfo()
            }
        }
    }

    function handleUpdateAvatar() {
        if (adminId >= 0) {
            updateManagerAvatar()
        } else {
            updateAdminAvatar()
        }
    }

    function updateManagerAvatar() {
        loading.show()
        service.updateManagerAvatar(
            adminId,
            imageFile
        ).then(response => {
            setImage(null)
            setImageFile(null)
            setAvatarUrl(response.url)
            snackbar.showSuccessMessage("تصویر ادمین با موفقیت بروزرسانی شد.")
            loading.hide()
        }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر ادمین"))
            loading.hide()
        })
    }

    function updateAdminAvatar() {
        loading.show()
        service.updateOwnAvatar(
            imageFile
        ).then(response => {
            setImage(null)
            setImageFile(null)
            setAvatarUrl(response.url)
            snackbar.showSuccessMessage("تصویر ادمین با موفقیت بروزرسانی شد.")
            loading.hide()
        }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر ادمین"))
            loading.hide()
        })
    }

    function updateManagerInfo() {
        loading.show()
        service.updateProfileDetailById(
            adminId,
            {
                "firstName": firstName,
                "lastName": lastName,
                "phoneNumber": phoneNumber
            }).then(response => {
            setProfileDetail(response)
            snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    function updateAdminInfo() {
        loading.show()
        service.updateProfileInfo({
            "firstName": firstName,
            "lastName": lastName,
            "phoneNumber": phoneNumber
        }).then(response => {
            setProfileDetail(response)
            snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    return (
        <section
            className={`default-card-container-background-style  ${css`
              padding: 16px;
              margin-top: 16px;
              display: flex;
              flex-direction: column;
            `}`}
        >
                    <span
                        className={css`
                          font-size: var(--text-size-large);
                          width: 100%;
                          flex-shrink: 0;
                          color: var(--color-text);
                        `}>
                        حساب کاربری
                    </span>
            <div className={
                css`display: flex;
                  margin-top: 24px;
                  gap: 16px;
                `}>


                <input type="file"
                       hidden={true}
                       onChange={onImageChange}
                       id="accountPhoto"
                />
                <img
                    src={image ? image : avatarUrl ? avatarUrl : avatarIcon}
                    className={
                        css`
                          width: 100px;
                          height: 100px;
                          border-radius: var(--default-border-radius);
                          background: var(--color-primary);
                          background-position: center center;
                          background-repeat: no-repeat;
                          object-fit: cover;
                          cursor: pointer;
                        `}
                    onClick={() => document.getElementById("accountPhoto").click()}
                    alt=""/>

                <div className={
                    css`display: flex;
                      flex-direction: column;
                      justify-content: end;
                      gap: 8px;
                    `}>

                    {
                        !image && <ButtonPrimaryRaiko
                            onClick={() => document.getElementById("accountPhoto").click()}
                            label={"تصویر جدید"}/>
                    }

                    {
                        image && <ButtonPrimaryRaiko
                            onClick={handleUpdateAvatar}
                            label={"بروزرسانی"}/>
                    }

                    <ButtonSecondaryRaiko
                        onClick={eraseImage}
                        label={"پاک کردن"}/>
                </div>
            </div>

            <div className={css`
              width: 100%;
              height: 1px;
              margin-top: 24px;
              background: var(--header-border-bottom-color) !important`}/>

            <Grid container spacing={"16px"} className={css`margin-top: 8px !important;`}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedInput
                            labelText={"نام"}
                            value={firstName}
                            onChange={({target}) => {
                                setFirstName(target.value)
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedInput
                            labelText={"نام خانوادگی"}
                            value={lastName}
                            onChange={({target}) => {
                                setLastName(target.value)
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedInput
                            labelText={"نام کاربری"}
                            value={userName}
                            disabled
                            onChange={({target}) => {
                                setUserName(target.value)
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedInput
                            placeHolder={"091..."}
                            labelText={"شماره همراه"}
                            className={css`direction: ltr;
                              text-align: end;`}
                            value={convertToMobileNumber(phoneNumber)}
                            onChange={({target}) => {
                                const _phoneNumber = convertToMobileNumber(target.value)
                                setPhoneNumber(_phoneNumber.replaceAll(" ", ""))
                            }}/>
                    </FormControl>
                </Grid>
            </Grid>

            <div className={css`display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: end;
              margin-top: 16px !important;
              gap: 16px;
            `}>
                <ButtonSecondaryRaiko
                    onClick={setProfileDataToFields}
                    label={"لغو"}/>
                <ButtonPrimaryRaiko
                    onClick={handleUpdateDetail}
                    label={"بروزرسانی"}/>
            </div>
        </section>
    )
}

export default UserProfileDetailPage;